// browsers and node do not recognize 'zt' as a locale, so we wrap DateTimeFormat to handle this case
export const DateTimeFormat = (
    locales?: string | string[],
    options?: Intl.DateTimeFormatOptions
): Intl.DateTimeFormat => new Intl.DateTimeFormat(locales === 'zt' ? 'zh-Hant' : locales, options);

/**
 * Transform a Date object into a formatted date string.
 */
export const getDateStringForLocale = (sourceDate: Date, locale: string | string[] = 'en-US', timeZone?: string) => {
    return DateTimeFormat(locale, {
        day: '2-digit',
        month: 'long',
        year: 'numeric',
        timeZone,
    }).format(sourceDate);
};

export const getMonthAndYearStringForLocale = (
    sourceDate: Date,
    locale: string | string[] = 'en-US',
    timeZone?: string
) => {
    return DateTimeFormat(locale, {
        month: 'long',
        year: 'numeric',
        timeZone,
    }).format(sourceDate);
};

export const getDurationSecondsFromDates = (startDate: Date, endDate: Date): number => {
    return Math.round((endDate.getTime() - startDate.getTime()) / 1000);
};

// Manually format to YYYY-MM-DD based on the object's timezone
// toISOString() requrie timezone calculation which can be finnky, especailly when seconds precsision is required
// For example, Year "0002" (which could happen as user is typing a date), China Standard Time is UTC+08:05:43
export const getFormattedDateString = (date: Date): string =>
    date.getFullYear().toString(10).padStart(4, '0') +
    '-' +
    (date.getMonth() + 1).toString(10).padStart(2, '0') +
    '-' +
    date.getDate().toString(10).padStart(2, '0');

/**
 * Compare two ISO Date Strings and return a value required by the sort() function (-1, 0, 1)
 * Oldest first by default. Swap a and b on inputs to have Newest First
 */
export const compareISODates = (a?: string | null, b?: string | null): number => {
    a = a ?? '0';
    b = b ?? '0';
    if (a < b) {
        return -1;
    }
    if (a > b) {
        return 1;
    }
    return 0;
};

/*
Hopefully we don't need this forever. Browser does not match node so we get Hydration errors.
https://bugs.chromium.org/p/chromium/issues/detail?id=1414292
https://bugzilla.mozilla.org/show_bug.cgi?id=1806042
https://chromium-review.googlesource.com/c/v8/v8/+/4237675
 */
export const sanitizeIcu = (dateString: string) => dateString.replace(/\s/g, ' ');
